// extracted by mini-css-extract-plugin
export default {"gallery":"c-g_eF","gallery__thumbs":"c-g_eG"};